var reInitGCaptcha;

function fn_layout_main() {

    reInitGCaptcha = function() {
        $.getScript("https://www.google.com/recaptcha/api.js?render=6Lc1HkUaAAAAAMZ6jNkRgw46rbHmor4WMtV-fp3c").done(function () {
            grecaptcha.ready(function () {
                grecaptcha.execute('6Lc1HkUaAAAAAMZ6jNkRgw46rbHmor4WMtV-fp3c', {action: 'form'})
                    .then(function (token) {
                        $('#g-token').val(token);
                    });
            });
        });
    };

    if ($('form[data-recaptcha]').length) {
        reInitGCaptcha();
        setInterval(function(){reInitGCaptcha();}, 150000);
    }

    $("body").removeClass("mod--preload");
    $(".lib--parallax").find("img:not(.lazyload)").parent().parallax();
    $(document).on('lazybeforeunveil', function(e){
        if ($(e.target).parent().hasClass("lib--parallax")) {
            $(e.target).parent().parallax();
        }
    });
    fn_scrollreveal();
    setTimeout(function () {
        $("body").addClass("mod--loaded");
    }, 300);

    $("[data-last-word]").nl_last_word();
}